export type CustomerTypeLabel = 'Concierge' | 'Self Pricing';

export const formatCustomerType = (pricingMode?: string | null): CustomerTypeLabel =>
  String(pricingMode || '').trim().toLowerCase() === 'self-pricing' ? 'Self Pricing' : 'Concierge';

export const formatNotesForDisplay = (
  notes: { n_type?: string; n_content?: string }[] | undefined,
  type: 'internal' | 'external',
): string => {
  const contents = (notes ?? [])
    .filter((note) => note?.n_type === type)
    .map((note) => String(note?.n_content ?? '').trim())
    .filter(Boolean);
  return contents.length ? contents.join(' · ') : 'N/A';
};

export const truncateNotePreview = (value: string, maxLength = 120): string => {
  if (value === 'N/A' || value.length <= maxLength) {
    return value;
  }
  return `${value.slice(0, maxLength).trim()}…`;
};
